/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResumeFineTuningJobRequest = {
  fineTuningJobId: string;
};

/** @internal */
export const ResumeFineTuningJobRequest$inboundSchema: z.ZodType<
  ResumeFineTuningJobRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  fine_tuning_job_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "fine_tuning_job_id": "fineTuningJobId",
  });
});
/** @internal */
export type ResumeFineTuningJobRequest$Outbound = {
  fine_tuning_job_id: string;
};

/** @internal */
export const ResumeFineTuningJobRequest$outboundSchema: z.ZodType<
  ResumeFineTuningJobRequest$Outbound,
  z.ZodTypeDef,
  ResumeFineTuningJobRequest
> = z.object({
  fineTuningJobId: z.string(),
}).transform((v) => {
  return remap$(v, {
    fineTuningJobId: "fine_tuning_job_id",
  });
});

export function resumeFineTuningJobRequestToJSON(
  resumeFineTuningJobRequest: ResumeFineTuningJobRequest,
): string {
  return JSON.stringify(
    ResumeFineTuningJobRequest$outboundSchema.parse(resumeFineTuningJobRequest),
  );
}
export function resumeFineTuningJobRequestFromJSON(
  jsonString: string,
): SafeParseResult<ResumeFineTuningJobRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResumeFineTuningJobRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResumeFineTuningJobRequest' from JSON`,
  );
}
